<h2 class="text-weight-600 text-primary text-center">{{ 'auth_forgot_password_success_title' | translate }}</h2>
<p class="mt-5 text-center">{{ 'auth_forgot_password_success_description' | translate }}</p>
